import { AppointmentType } from 'kb-shared/types';

export const CONNECT_TO_CARE_SOURCE = 'connect';
// Added to the booking URL when the quiz opens a type itself, so the booking page's Back
// returns to the last quiz question.
export const QUIZ_AUTO_SELECTED_PARAM = 'from_quiz';

// Quiz answers map to one appointment type (its in-clinic/virtual pair is linked through
// inClinicOrVirtualEquivalent), an in-clinic + virtual pair, or several types (Third Party
// Consultation). Returns the type to open, preferring virtual, or null to keep the
// "We recommend..." step.
export const autoSelectAppointmentType = (
  appointmentTypes: Array<AppointmentType>
): AppointmentType | null => {
  if (appointmentTypes.length === 1) {
    const [appointmentType] = appointmentTypes;
    const equivalent = appointmentType.inClinicOrVirtualEquivalent;

    if (!appointmentType.virtual && equivalent?.virtual && !equivalent.disableOnlineBooking) {
      return equivalent;
    }

    return appointmentType;
  }

  if (appointmentTypes.length === 2) {
    const virtualAppointmentTypes = appointmentTypes.filter(
      appointmentType => appointmentType.virtual
    );

    return virtualAppointmentTypes.length === 1 ? virtualAppointmentTypes[0] : null;
  }

  return null;
};
